/**
 * Checks if the given URL is allowed by the domains configuration.
 * @param {URL} url - URL to validate (origin + path from host)
 * @param {Array<{ normalizedHostname?: string, normalizedPathname?: string, domain?: string, includeSubpages?: boolean }>} domainsArray
 * @returns {boolean}
 */
export function isCurrentUrlAllowed(url, domainsArray) {
	if (!Array.isArray(domainsArray) || domainsArray.length === 0) {
		console.warn("[WIDGET] No domains configured for validation.");
		return false;
	}
	const normalizeHost = (h) => h.replace(/^www\./i, "").toLowerCase();
	const normalizePath = (p) => (p === "/" ? "" : p.replace(/\/+$/, ""));

	const currentHost = normalizeHost(url.hostname);
	const currentPath = normalizePath(url.pathname);

	return domainsArray.some((entry) => {
		try {
			const { normalizedHostname, normalizedPathname, includeSubpages } = entry;

			let entryHost = normalizedHostname;
			let entryPath = normalizedPathname;

			if (!entryHost || !entryPath) {
				let domain = entry.domain || "";
				if (!domain.startsWith("http://") && !domain.startsWith("https://")) {
					domain = `https://${domain}`;
				}
				const entryURL = new URL(domain);
				entryHost = normalizeHost(entryURL.hostname);
				entryPath = normalizePath(entryURL.pathname);
			}

			if (currentHost !== entryHost) {
				console.warn(`[HOST MISMATCH] Skipping. ${currentHost} !== ${entryHost}`);
				return false;
			}

			if (includeSubpages) {
				return currentPath.startsWith(entryPath);
			}
			return currentPath === entryPath;
		} catch (e) {
			console.error("[WIDGET] Domain matching error for entry:", entry, e);
			return false;
		}
	});
}
